<div class="col-lg-11 row mt-3">
    <div class="col-12 col-lg-6 mb-3">
        <div class="text-center">
            <img src="assets/icons/welcome.jpg" alt="Welcome to gamtest" class="img-fluid" style="width:80%">
        </div>
    </div>
    <div class="col-12 col-lg-6">
        <h1>
            {{ 'si_pts_chrome_gamtest_start_header' | cmsText | async }}
        </h1>
        <p [appParagraph]="1">
            {{ 'si_pts_chrome_gamtest_start_text' | cmsText | async }}
        </p>

        <div class="d-grid gap-2 col-12">
            <a appStandardButton [routerLink]="'/dialogs/gamtest'">{{ 'si_pts_chrome_gamtest_start_yes' | cmsText | async }}</a>
            <a appLinkButton [routerLink]="['/dashboard']">{{ 'si_pts_chrome_gamtest_start_no' | cmsText | async }}</a>
        </div>

    </div>
</div>
